import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/tasks/importer/tasksImporterActions'

export default importerReducers(actions)
